import { render } from "./pageCMS.vue?vue&type=template&id=1340a7af"
import script from "./pageCMS.vue?vue&type=script&lang=js"
export * from "./pageCMS.vue?vue&type=script&lang=js"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__